// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const isInputWithPath = (input) => {
    return input.path !== undefined;
};

export { isInputWithPath };
//# sourceMappingURL=isInputWithPath.mjs.map
